import React, { useContext, useState } from 'react';
import { useTranslation } from '@common/hooks/translation';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';
import NumericInput from '@common/components/numericInput';

const TransferToAccount = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);
  const [clientId, setClientId] = useState('');
  const [clientNotFound, setClientNotFound] = useState(false);
  const handleChange = (value) => {
    const valMoney = /^[0-9]*$/;

    if (valMoney.test(value)) {
      setClientId(value);
    }
  };
  const findPlayer = () => {
    const { token } = JSON.parse(sessionStorage.getItem('authData'));
    swarmRequest(
      { token, filter: { id: +clientId } },
      'terminal_find_player',
    )
      .then((response) => {
        const client = response.data[0];
        if (client) {
          openPopup(POPUPS.TRANSFER_TO_ACCOUNT_DETAILS, { client });
        } else {
          setClientNotFound(true);
        }
      });
  };
  return (
    <div className="popup-content popup-small">
      <p className="popup-title">{t('Transfer to Account')}</p>
      <p className="popup-title">{t('Enter the client ID to which you want to transfer the money')}</p>
      <div className="popup-main-content">
        <div className="input-wrapper">
          <p className="popup-txt">{t('Client ID')}</p>
          <div className="input-row">
            <NumericInput
              type="text"
              className="numeric-input"
              value={clientId}
              onChange={handleChange}
            />
          </div>
        </div>
        {
          clientNotFound
          && <p className="error-message">{t('No account was found with this Id')}</p>
        }
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={closePopup}
        >
          Cancel
        </button>
        <button
          type="button"
          disabled={!clientId}
          className="popup-confirm-button"
          onClick={findPlayer}
        >
          Find
        </button>
      </div>
    </div>
  );
};
export default TransferToAccount;
